import React, { useEffect, useRef, useState } from 'react';
import './Header.css';
import { Link } from 'react-router-dom';
import franceFlag from '../Images/FranceFlag.jpeg';
import germanyFlag from '../Images/GermanyFlag.jpg';
import logo from '../Images/Logo.webp';
import DropdownMenu from './DropDownMenu';
import { useLanguage } from '../contexts/LanguageContext';

function Header() {
  const { language, setLanguage, t } = useLanguage();
  
  const pages: { title: string; url: string }[] = [
    { title: t('header.nav.home'), url: `/${language}/home` },
    { title: t('header.nav.about'), url: `/${language}/about` },
    { title: t('header.nav.services'), url: `/${language}/services` },
    { title: t('header.nav.forms'), url: `/${language}/forms` },
    { title: t('header.nav.contact'), url: `/${language}/contact` },
  ];

  const [hidden, setHidden] = useState(false);
  const lastY = useRef<number>(0);
  const ticking = useRef<boolean>(false);

  useEffect(() => {
    const threshold = 8;

    function onScroll() {
      if (ticking.current) return;
      ticking.current = true;

      requestAnimationFrame(() => {
        const currentY = window.scrollY || window.pageYOffset;
        // Show/hide header on scroll for all viewports: hide when scrolling down,
        // show when scrolling up. Small threshold avoids jitter on small deltas.

        if (Math.abs(currentY - lastY.current) < threshold) {
          ticking.current = false;
          return;
        }

        if (currentY > lastY.current && currentY > 50) {
          setHidden(true);
        } else if (currentY < lastY.current) {
          setHidden(false);
        }

        lastY.current = currentY;
        ticking.current = false;
      });
    }

    const onResize = () => setHidden(false);

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
    };
  }, []);

  return (
    <>
      <header className={`header ${hidden ? 'hidden' : ''}`}>
        <DropdownMenu pages={pages} />
        <nav className="desktop-nav desktop-nav-left">
          {pages.filter(page => !page.url.endsWith(`/${language}/home`)).slice(0, 2).map((page) => (
            <Link key={page.url} to={page.url} className="nav-link">
              {page.title}
            </Link>
          ))}
        </nav>
        <div className="logo-container">
          <div className="logo">
            <Link to={`/${language}/home`}>
              <img src={logo} alt="GrenzExpert" className="logo" />
            </Link>
          </div>
        </div>
        <nav className="desktop-nav desktop-nav-right">
          {pages.filter(page => !page.url.endsWith(`/${language}/home`)).slice(2, 4).map((page) => (
            <Link key={page.url} to={page.url} className="nav-link">
              {page.title}
            </Link>
          ))}
        </nav>
        <div className="flags-container">
          <img 
            src={germanyFlag} 
            alt="Drapeau Allemand" 
            className={`flag ${language === 'de' ? 'flag-active' : ''}`}
            onClick={() => setLanguage('de')}
            style={{ cursor: 'pointer' }}
          />
          <img 
            src={franceFlag} 
            alt="Drapeau Français" 
            className={`flag ${language === 'fr' ? 'flag-active' : ''}`}
            onClick={() => setLanguage('fr')}
            style={{ cursor: 'pointer' }}
          />
        </div>
      </header>
      {/* Spacer for mobile only - compensates for fixed header */}
      <div className="header-spacer"></div>
    </>
  );
}

export default Header;
